import TransformComponent from '../../../../Component/Transform';
import CardComponent from '../../../../Component/Level/Card';
import Renderable from '../../../../Component/Renderable';
import CardStateHelper from '../../../../State/Card/CardStateHelper';
import CardSystem from '../../CardSystem';
import { ICardsState } from '../../../../State/Card/ICardState';
import CardModifier from 'Prototype/Level/Card/Modifier/CardModifier';
import CardModifierComponent from 'Component/Level/CardModifier';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class BaseCardModifierHandler {
    public modifier: CardModifier;
    public modifierComponent: CardModifierComponent;
    public transform: TransformComponent;
    public cardComponent: CardComponent;
    public renderable: Renderable;

    constructor(modifier: CardModifier) {
        this.modifier = modifier;

        this.modifierComponent = this.modifier.getComponent(CardModifierComponent);
        this.transform = this.modifier.getComponent(TransformComponent);
        this.cardComponent = this.modifier.getComponent(CardComponent);
        this.renderable = this.modifier.getComponent(Renderable);
    }

    public handleStateChange(state: ICardsState, cardSystem: CardSystem) {
        switch (CardStateHelper.getCardState(state, this.modifierComponent.cardID)) {
            case CardState.IN_PLAY:
                this.handleModifierInPlay(state, cardSystem);
                break;
            case CardState.IN_STACK:
                this.handleModifierInStack(state, cardSystem);
                break;
            case CardState.FOLDED:
                this.handleModifierFolded(state, cardSystem);
                break;
            case CardState.DISCARDED:
                this.handleModifierDiscarded(state, cardSystem);
                break;
            case CardState.UNKNOWN:
                this.handleModifierUnknown(state, cardSystem);
                break;
        }
        
        this.modifierComponent.properties = this.getModifierStateData(state).properties;
    }

    protected handleModifierInPlay(state: ICardsState, cardSystem: CardSystem) {}
    protected handleModifierInStack(state: ICardsState, cardSystem: CardSystem) {}
    protected handleModifierFolded(state: ICardsState, cardSystem: CardSystem) {}
    protected handleModifierDiscarded(state: ICardsState, cardSystem: CardSystem) {}
    protected handleModifierUnknown(state: ICardsState, cardSystem: CardSystem) {}

    public setModifierFaceUp(faceUp: boolean) {
        this.updateVisibility(faceUp);
    }

    protected updateVisibility(visible: boolean): void {
        this.renderable.visible = visible;
    }

    protected getModifierStateData(cardsState: ICardsState) {
        const card = cardsState.cards[this.modifierComponent.cardID];
        return card.modifiers.find(data => data.type === this.modifierComponent.type);
    }
    
    public clearModifier(): void {
        this.modifier.destroy();
    }
}
